export default __webpack_public_path__ + "static/media/footstepsInSnow.9d368718.jpeg";